import styles from './APIUsage.module.scss';
import { useLayoutEffect } from 'react';
import { AppRoutes } from 'src/types';
import { useSession } from 'src/hooks';
import { useNavigate } from 'react-router-dom';
import { APIUsageTable } from 'src/pages/ManageAccountPage/components/APIUsage/components/APIUsageTable';
import { AddOnContainer } from 'src/pages/AddOnPage/components/AddOnContainer';

export const APIUsage = () => {
  const { isOpenTier } = useSession();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    if (isOpenTier) {
      navigate(AppRoutes.HOME);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpenTier]);

  return (
    <AddOnContainer>
      <div className={styles.root}>
        <APIUsageTable />
      </div>
    </AddOnContainer>
  );
};
